export default {
    sessionKey: 'session',
    isLogged () {
      if (!window.localStorage) return null
      const session = window.localStorage.getItem(this.sessionKey)
      return (session)
    },
    setSession (session) {
      if (window.localStorage) {
        window.localStorage.setItem(this.sessionKey, session)
      } else {
        throw new Error('Su navegador no soporta este tipo de autenticación, favor de actualizarlo.')
      }
    },
    getSession () {
      if (!window.localStorage) return null
      var parsedSession = this.parseJWT(window.localStorage.getItem(this.sessionKey))
      return this.mapSession(parsedSession)
    },
    removeSession () {
      if (!window.localStorage) return null
      window.localStorage.removeItem(this.sessionKey)
    },
    getAccessToken () {
      if (window.localStorage) {
        return window.localStorage.getItem(this.sessionKey)
      } else {
        throw new Error('Su navegador no soporta este tipo de autenticación, favor de actualizarlo.')
      }
    },
    parseJWT (token) {
      if (!token) return null
      var base64Url = token.split('.')[1]
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      while (base64.length % 4) base64 += '='
      return JSON.parse(window.atob(base64))
    },
    mapSession (session) {
      if (!session) return null
      // JWT emitido por AuthService.LoginAsync contiene:
      // NameIdentifier, Name, UniqueName, Sub, Jti, role (ClaimTypes.Role),
      // y claims Permission (type="Permission", value="Permission.Module.Code").
      return {
        userId: session.nameidentifier,
        username: session.name,
        email: session.sub,
        exp: session.exp,
        aud: session.aud,
        iss: session.iss,
        // HIGH-09: roles y permissions enriquecidos en el JWT
        roles: Array.isArray(session.role) ? session.role : (session.role ? [session.role] : []),
        permissions: Array.isArray(session.permission) ? session.permission : (session.permission ? [session.permission] : []),
      }
    }
  }
  